import { JepGraphic } from '@jeppesen-foreflight/jmkw-types';
/* eslint-disable @typescript-eslint/no-unsafe-declaration-merging */
import { FeatureDetail } from './feature-detail';
import { RunwayAttributes } from './runway-attributes';
import { NavigationFeatureType } from '../navigation-feature-type';

// Keep interface for structural typing (useful in other places)
// eslint-disable-next-line @typescript-eslint/no-redeclare -- deliberate interface/class pairing used for both type and value
export interface Runway extends FeatureDetail {
  attributes: RunwayAttributes;
  material: string;
  size: string;
}

// Provide a concrete class so Runway can be referenced as a value (constructor) where needed.
export class Runway implements Runway {
  navType: NavigationFeatureType = 'runway';
  id: string;
  attributes: RunwayAttributes;
  material: string;
  size: string;

  constructor(public graphic?: JepGraphic) {
    // Map raw attributes defensively (legacy data may omit fields)
    const attrs: any = graphic?.attributes || {};
    this.id = attrs.runwayident || attrs.id || '';
    this.material = attrs.rwysurface || attrs.surface || '';
    this.size = this._formatSize(attrs.length, attrs.width);
    this.attributes = {
      ...attrs
    } as RunwayAttributes; // shallow copy; refine typing later
  }

  private _formatSize(length?: number, width?: number): string {
    if (length && width) return `${length}x${width}`;
    if (length) return `${length}`;
    return '';
  }
}
